import { render, staticRenderFns } from "./addCSG.vue?vue&type=template&id=814e410a"
import script from "./addCSG.vue?vue&type=script&lang=js"
export * from "./addCSG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('814e410a')) {
      api.createRecord('814e410a', component.options)
    } else {
      api.reload('814e410a', component.options)
    }
    module.hot.accept("./addCSG.vue?vue&type=template&id=814e410a", function () {
      api.rerender('814e410a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/user/account/addCSG.vue"
export default component.exports